import { useTheme } from '@automata/mui-theme';
import { secondsToDurationString } from '@automata/utils/time';
import { AxisScale, AxisTop } from '@visx/axis';
import { Group } from '@visx/group';

import { AxisTickComponent } from './Tick';

export type AxisXProps = {
  scale: AxisScale;
  width: number;
  height: number;
  margin: { left: number; top: number };
};

export const AxisX = ({ scale, width, height, margin }: AxisXProps) => {
  const theme = useTheme();
  const minTickSpacing = 12;
  const numTicks = Math.floor(width / minTickSpacing);
  return (
    <Group>
      <Group left={margin.left}>
        <rect
          x={0}
          y={0}
          width={Math.max(width - margin.left, 0)}
          height={Math.max(height, 0)}
          fill={theme.palette.neutral[300]}
        />
      </Group>
      <AxisTop
        scale={scale}
        hideAxisLine
        ticksComponent={({ ticks }) => (
          <g>
            {ticks.map((tick) => (
              <AxisTickComponent
                key={`tick-${tick.value}`}
                index={tick.index}
                formattedValue={tick.formattedValue}
                x={tick.from.x}
                y={tick.from.y}
              />
            ))}
          </g>
        )}
        numTicks={numTicks}
        hideZero={false}
        tickFormat={(numValue) => secondsToDurationString(numValue.valueOf())}
        top={height}
        left={margin.left}
      />
    </Group>
  );
};
